import options from '../config/optionsContacts';
import markerFragment from '../config/marker';
import {SaveToFavorites} from "../../../../../scripts/save-to-favorites/save-to-favorites";

const moment = require('moment');
const lang = $('body').data().locale;
const enPrefix = lang === 'en' ? '/en' : '';
moment.locale(lang);

window.addEventListener('load', () => {

    (function () {

        let getPropertyData = $("#offer-map").data('property');
        //Get Media Thumbnail
        const getPropertyThumbnail = $('[data-property-view="true"]').data('media');

        const mapPanel = $(".map-property-panel");

        const lat = parseFloat(mapPanel.data("lat"));
        const lng = parseFloat(mapPanel.data("long"));

        const checkFavorited = $('#favoriteCheckbox').data('favorited');

        function initMap() {
            const property = {lat: +lat, lng: +lng};
            let _mapOptions = options;
            const map = new google.maps.Map(document.getElementById('mapItem'), _mapOptions);
            let _infoWindow = new google.maps.InfoWindow({content: ''});
            const authentication = $('.offer-details').data('auth');

            const icon = markerFragment;
            const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

            const marker = new google.maps.Marker({
                title: lang.room_office,
                position: property,
                map: map,
                icon: {
                    url: (isIE11 ? "http://maps.google.com/mapfiles/ms/icons/red-dot.png" : 'data:image/svg+xml, ' + encodeURI(icon)),
                    scaledSize: (isIE11 ? new google.maps.Size(27, 27) : new google.maps.Size(21, 21))
                }
            });

            let contentAuthFalse = '';
            let contentAuthTrue = '';

            let content = '';

            contentAuthTrue = `
                            <div class="offer-item">
                                <div class="offer-image-panel">
                                    <span class="checkbox-star-panel" 
                                          data-toggle="tooltip" 
                                          data-original-title="${jsLangs.favorite_offices}">
                                        <label class="checkbox-star" 
                                               data-trigger="auth-true" 
                                               data-item-key="${getPropertyData.id}">
                                            <input type="checkbox" name="favourites" ${checkFavorited}>
                                            <span class="checkmark"></span>
                                        </label>
                                    </span>
                                    <a href="/properties/${getPropertyData.slug}" class="offer-map-image">
                                        <div class="offer-image zoom" style="background-image: url('${typeof getPropertyThumbnail !== 'undefined' ? getPropertyThumbnail : '/assets/images/placeholders/placeholder-small.jpg'}');"></div>
                                    </a>
                                 </div>
                                 <div class="offer-info">
                                        <div class="offer-title">${getPropertyData.title}</div>
                                        <div class="offer-location">
                                            ${getPropertyData.address}
                                        </div>
                                        <div class="d-flex justify-content-between">
                                        <div class="offer-price"> ${getPropertyData.monthly_rent} € </div>
                                            <div class="offer-surface"> ${getPropertyData.total_floorage} кв.м.</div>
                                        </div>
                                        <div class="offer-row-label">
                                             <button type="button" 
                                                     class="time-label" 
                                                     data-toggle="tooltip" 
                                                     data-placement="top" 
                                                     title="${moment(getPropertyData.created_at).format('YYYY-MM-D')}">
                                                ${moment(getPropertyData.created_at).toNow(true)}
                                            </button>
                                            <a href="${enPrefix}/properties/${getPropertyData.slug}"
                                               title="${getPropertyData.title}"
                                               class="offer-link">${jsLangs.see_more}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>`;
            console.log('getPropertyData : ', getPropertyData.created_at);

            // *** User is Logged Out
            contentAuthFalse = `
                            <div class="offer-item">
                                <div class="offer-image-panel">
                                     <span class="checkbox-star-panel checkbox-star-false" 
                                           data-toggle="tooltip" 
                                           data-original-title="${jsLangs.registration_needed_favorites}">
                                        <span class="checkbox-star">
                                            <span class="checkmark"></span>
                                        </span>
                                      </span>
                                      <a href="/properties/${getPropertyData.slug}" title="${getPropertyData.title}" class="offer-map-image">
                                        <div class="offer-image zoom" style="background-image: url('${typeof getPropertyThumbnail !== 'undefined' ? getPropertyThumbnail : '/assets/images/placeholders/placeholder-small.jpg'}');"></div>
                                     </a>
                                </div>
                                <div class="offer-info">
                                    <div class="offer-title"> ${getPropertyData.title} </div>
                                        <div class="offer-location d-flex align-items-center flex-wrap">
                                            <span class="text-regular mr-2">${jsLangs.location}: </span>
                                            <span class="text-regular ellipsis blur-effect-soft">${jsLangs.sample_location}</span>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                        <div class="offer-price blur-effect-soft">000 000 €</div>
                                            <div class="offer-surface blur-effect-soft"> 000 кв.м.</div>
                                        </div>
                                        <div class="offer-row-label">
                                             <button type="button" 
                                                     class="time-label" 
                                                     data-toggle="tooltip" 
                                                     data-placement="top" 
                                                     title="${moment(getPropertyData.created_at).format('D-MM-YYYY HH:mm:s')}">
                                                ${moment(getPropertyData.created_at).toNow(true)}
                                            </button>
                                            <a href="${enPrefix}/properties/${getPropertyData.slug}" title="${getPropertyData.title}" class="offer-link">${jsLangs.see_more}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>`;

            function showContent() {
                /* -- User Auth Guard -- */
                (authentication ? content = contentAuthTrue : content = contentAuthFalse);
                /* ----------------------- */
                _infoWindow.setContent(content);
                _infoWindow.open(map, marker);

                function isInfoWindowOpen(infoWindow) {
                    const map = infoWindow.getMap();
                    return (map !== null && typeof map !== "undefined");
                }

                if (isInfoWindowOpen(_infoWindow)) {
                    setTimeout(function () {
                        SaveToFavorites();
                    }, 500);
                }
            }

            showContent();

            marker.addListener('click', function () {
                showContent();
            });
            _infoWindow.open(map, marker);
        }

        initMap();
    })();
});
